import type {FunctionComponent} from "react";
import {ErrorOutline} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";
import ToastContent from "../../index";

export interface IErrorToastContent {
    message: string,
    title?: string,
}

const ErrorToastContent: FunctionComponent<ToastContentProps<IErrorToastContent>> = (props) => {

    return (
        <>
            <ToastContent
                title={props.data.title}
                message={props.data?.message ?? ''}
                icon={<ErrorOutline color={'error'}/>}
                className={typeof props.toastProps.className === 'string' ? props.toastProps.className : ''}
                toastProps={props.toastProps}
            />
        </>
    )
}

export default ErrorToastContent;
